import { AppStrings } from '../messages';

export const French: AppStrings = {
    or: ' ou ',
    max: 'max.',
    accept: 'Accepter',
    submit: 'Envoyer',
    back: 'Retour',
    purchase: 'Acheter',
    no_thanks: 'Non merci',
    thank_you: 'Merci!',
    cancel: 'Annuler',
    close: 'Fermer',
    click_here_to_get_code: 'Cliquez ici pour obtenir votre code',
    open: 'Open',
    option_unavailable: 'Ce n’est actuellement pas disponible',
    confirm: 'Confirmer',

    my_trip: 'Mon voyage',
    finalize_trip: 'Finalisez votre voyage',
    trip_all_set: 'Votre voyage est prêt',
    manage_guests_capitalized: 'Inviter Les Invités',
    manage_guests_title: 'Inviter les invités',
    manage_pets_title: 'Ajouter/Supprimer des Shiens',
    manage_pets_error:
        "Désolé, une erreur s'est produite. Pour parler avec un représentant du service à la clientèle, appelez le 1-800-544-0300",
    add_remove_guest: 'Ajouter ou Supprimer un Invité',
    modify_your_trip: 'Modifier votre voyage',
    instructions_for_modify_guests:
        'Faites-nous savoir combien d´adultes et d´enfants (plus de 2 ans) séjourneront. Si vos plans ne sont pas encore finalisés, ajoutez les invités que vous connaissez pour le moment. Vous pourrez revenir et mettre à jour ces informations plus tard.',
    instructions_for_modify_guests_pets:
        'Faites-nous savoir combien d´adultes, d´enfants (plus de 2 ans) et de chiens y séjourneront. Si vos plans ne sont pas encore finalisés, ajoutez les invités que vous connaissez pour le moment. Vous pourrez revenir et mettre à jour ces informations plus tard.',

    instructions_for_modify_pets: "Ami à quatre pattes et queues agitées bienvenues. Ajoutez jusqu'à {pets} chiens à votre séjour.",
    instructions_for_modify_pet: "Ami à quatre pattes et queues agitées bienvenues. Ajoutez jusqu'à 1 chien à votre séjour.",
    extra_instructions_for_modify_pet:
        "As changé d'avis? Nous vous rembourserons tous les frais payés pour les animaux de compagnie dans les 5 jours ouvrables.",
    max_occupancy_modify_guests:
        'L´occupation max. est de {max_occupancy} {guests}. Des frais supplémentaires peuvent s´appliquer et seront indiqués ci-dessous.',
    getting_there: 'Accès',
    in_the_home: 'Dans le logement',
    checkout_instructions: 'Instructions Pour le Départ',
    codes_will_be_provided: 'Vous recevrez vos codes 1 semaine avant la date de votre arrivée',
    passwords_will_be_provided: 'Vous recevrez votre mot de passe 1 semaine avant la date de votre arrivée',
    alarm_code: 'Code de l’alarme',
    lockbox_code: 'Code du coffret sécurisé',
    e_lock_codes: 'Codes des serrures électroniques',
    gate_access: 'accès au portail',
    stay_longer: 'Rester un peu plus',
    location_and_parking: 'Emplacement & stationnement',
    on_your_way: 'En route',
    directions_to_know: 'Indications à connaître',
    directions_and_parking_notes: 'Indications et stationnement',
    parking_spaces: 'Places de parking',
    parking_notes: 'Notes de stationnement',
    entering_home: 'Entrer dans le logement',
    home_access_details: 'Informations pour accéder au logement',
    house_rules: 'Règlement intérieur',
    internet_access: 'Accès Internet',
    network: 'Réseau',
    password: 'Mot de passe',

    reservation: 'Réservation',
    trip_overview: 'Aperçu du voyage',
    nights: 'Nuits',
    max_occupancy: 'Nombre maximum d’occupants',
    can_add_guest: 'Vous pouvez ajouter jusqu`à {total} {guests} supplémentaires',
    can_not_add_guest: 'Vous avez atteint le nombre maximum d`invités',
    guest: 'Invité',
    guests: 'Invités',
    confirmation: 'Confirmation',
    view_listing: 'Voir l’annonce',

    rental_agreement: 'Contrat de location',
    sign_agreement: 'Signer le contrat',
    sign_by: 'Revoir et signer par {signBy}',
    sign_agreement_by: 'Veuillez accepter les détails de votre contrat de location d’ici au {signBy}',
    signed_on: 'Signé le {signedOn}',
    i_agree_terms: "J'accepte les conditions générales ci-dessus",
    agreed_on: 'Vous avez accepté ces conditions le {agreedOn}',
    i_agree_new_terms: `J'accepte le <a  target="_blank" rel="noopener noreferrer" href="{rental_agreement_url}">Contrat de Location</a> de Vacasa, <a  target="_blank" rel="noopener noreferrer" href="{privacy_policy_url}">Politique de Confidentialité</a>, et `,
    agreed_new_terms_on: `Vous avez accepté le <a  target="_blank" rel="noopener noreferrer" href="{rental_agreement_url}">Contrat de Location</a> de Vacasa, <a  target="_blank" rel="noopener noreferrer" href="{privacy_policy_url}">Politique de Confidentialité</a>, et `,
    agreed_new_terms_on_date: ` le {date}`,
    unit_terms_text: `Termes Spécifiques de l'Unité`,
    unit_terms_alert: `Sauf indication contraire dans le `,
    new_terms_required_text: `Requis`,
    new_terms_instructions_text: `Vérifiez les règles de la maison et confirmez l'accord ci-dessous`,
    new_terms_submit_btn: `Soumettre`,
    view_agreement: 'Voir le contrat',
    print_header_text: 'Veuillez suivre ces instructions. Vous serez averti une fois que nous aurons reçu et traité votre accord',
    print_step_one: 'Imprimer, réviser et signer cet accord',
    print_step_two: 'Envoyez-le nous par email ou fax',
    print_button: 'Imprimer',
    print_email_label: 'Email',
    print_fax_label: 'Fax',
    print_email_value: 'info@vacasa.com',
    print_fax_value: '(503) 897-7036',
    print_booked_by: 'Réservé par',
    print_on: 'sur',

    payment_details: 'Détails du paiement',
    make_payment: 'Effectuer un paiement',
    pay_balance: 'Payer le Solde',
    balance_due: 'Solde dû',
    payment_complete: 'Paiement effectué',
    pay_by: '{total} dû d´ici {payBy}',
    pay_balance_by: 'Payez votre solde avant le {payBy}',
    view_receipt: 'Voir le reçu',

    refund_going_to: 'Remboursement allant à',
    original_payment_methods: "Méthode(s) de paiement d'origine",
    guest_paid: "L'invité a payé {amount} le {date}",
    refund_details: 'Détails du remboursement',
    total_refund: 'Remboursement total',
    original_payment: 'Paiement Initial',

    cancellation_charges: "Frais d'annulation",
    sure_you_want_to_cancel: 'Êtes-vous sûr de vouloir annuler votre voyage?',
    yes_cancel_now: 'Oui, Annuler Maintenant.',
    no_dont_cancel: "Non, N'Annulez Pas.",
    cancel_trip: 'Annuler le voyage',
    cancel_and_receive_refund: 'Annuler et recevoir le remboursement',
    view_cancellation_policy: `Afficher les conditions d'annulation`,

    balance_in: 'Solde en {currency}',
    total_in: 'Montant total en {currency}',
    total_with_security_deposit_in: 'Montant total avec dépôt de sécurité en {currency}',
    security_deposit: 'Dépôt de sécurité',
    new_balance_due: 'Nouveau solde en {currency}',
    processed_in_currency_notice:
        'Veuillez noter que cette opération a été réalisée en {currency}. Les taux de change sont approximatifs et sujets à variations.',
    vehicle_registration: 'Immatriculation des véhicules',
    vehicle: 'Véhicule',
    list_your_vehicles: 'Les véhicules de votre groupe',
    register_vehicle: 'Enregistrer le véhicule',
    max_vehicles_reached: 'Le nombre maximum de véhicules est atteint',
    group_has_no_vehicles: 'Mon groupe n’a pas de véhicule',
    register_by: 'Ajouter tous les véhicules d´ici le {registerBy}',
    register_vehicles_by: 'Veuillez enregistrer vos véhicules d’ici au {registerBy}',
    add_vehicle_info: 'Ajouter des informations sur les véhicules',
    add_a_vehicle_button: 'Ajouter véhicule',
    add_vehicle_title: 'Ajouter un véhicule',
    add_vehicle_text: 'Ajouter un véhicule à votre voyage.',
    vehicle_added: 'Informations véhicule ajoutées',
    edit_a_vehicle_button: 'Sauvegarder les Modifications',
    edit_vehicle_title: 'Modifier un véhicule',
    edit_vehicle_text: 'Modifier vos informations véhicules.',
    remove_vehicle_text: 'Retirer un véhicule de votre voyage.',
    remove_vehicle_title: 'Retirer un véhicule',
    remove_vehicle_button: 'Supprimer',
    my_group_has_no_vehicles_title: 'Mon groupe n’a pas de véhicule',
    my_group_has_no_vehicles_confirm_text:
        "Vous pourriez être condamné à une amende par la ville ou par le HOA si votre groupe apporte un véhicule sans l'avoir enregistré à l'avance.",
    my_group_has_no_vehicles_confirm_button: 'Confirmer zéro Véhicules',
    license_plate: 'Plaque d’immatriculation',
    state_province: 'État/province',
    other: 'Autre',
    location: 'Emplacement',

    add_on: 'Supplément',
    pool_heat: 'Chauffage de la piscine',
    pool_heat_added: 'Chauffage de la piscine ajouté',
    pool_heat_note:
        'Améliorez votre séjour avec notre option de chauffage de piscine ! Plongez dans le confort et la chaleur à chaque baignade.',

    finalize_your_reservation: 'Finaliser votre réservation',
    these_actions_are_required: 'Vous devez effectuer ces actions pour obtenir les détails de votre enregistrement.',

    need_help: "Besoin d'aide ?",
    visit_our: 'Consultez notre',
    support_center: 'Centre de soutien',
    still_have_questions: "Vous avez d'autres questions ?",
    please_reach: 'Veuillez contacter:',
    home_essentials: 'Le logement en bref',
    no_beds: 'Pas de lits',
    king_bed: 'grand lit double',
    king_bed_plural: 'grand lits doubles',
    queen_bed: 'grand lit',
    queen_bed_plural: 'grand lits',
    double_bed: 'lit double',
    double_bed_plural: 'lits doubles',
    twin_bed: 'lit jumeaux',
    twin_bed_plural: 'lits jumeaux',
    child_bed: 'lit pour enfant',
    child_bed_plural: 'lits pour enfants',
    murphy_bed: 'lit escamotable',
    murphy_bed_plural: 'lits escamotables',

    no_bathrooms: 'Pas de salles de bains',
    full_bath: 'salle de bain complète',
    full_bath_plural: 'bains complets',
    half_bath: 'demi bain',
    half_bath_plural: 'demi bains',

    sleeps: 'Dorment',
    loading: 'Chargement',
    updated_successfully: 'Mise à jour réussie',
    read_more: '... Lire la suite',
    read_less: '... Lire moins',

    who_is_coming: 'Qui vient',
    invite_guest: 'ajouter un invité',
    invite_guest_note: 'Les invités recevront un e-mail {daysBefore} jours avant le voyage du.',
    invite_guest_note_same_day: "Les invités recevront un e-mail d'enregistrement détaillé le jour de leur arrivée",
    add_guest: 'Ajouter des invités',
    edit_guest: 'Modifier invité',
    remove_guest: 'Retirer invité',
    edit_guest_note_modal: "Modifier les invités pour partager l’itinéraire et les informations d'accès de votre voyage.",
    invite_guest_info: 'Ajouter des informations sur les invités',
    email_addresses_guests: 'Adresse e-mail',
    modify_guest_note: 'Vous pouvez ajouter des invités à votre voyage ou en retirer.',
    modify_guest_add_note: 'Vous pouvez ajouter jusqu’à {remainingGuests} invités supplémentaires',
    need_cancel_trip: "Besoin d'annuler votre voyage ?",
    need_cancel_note: "Si vous avez besoin d'annuler votre voyage, veuillez lire les conditions d'annulation ici.",
    cancel_trip_options: "Voir les options d'annulation",
    name: 'Nom',
    first_name: 'Prénom',
    last_name: 'Nom',
    email_address: 'Adresse e-mail',
    invite_guest_note_modal: "Ajouter vos invités pour partager l’itinéraire et les informations d'accès de ce voyage.",
    yes_remove_invited: 'Oui',
    no_remove_invited: 'Ce n’est pas grave',
    can_add_pet: "Ajoutez jusqu'à {total} ami à fourrure",
    can_add_pets: "Ajoutez jusqu'à {total} amis à fourrure",
    can_not_add_pet: 'Vous avez atteint le nombre maximum de chiens',
    add_pet_refund_btn: 'Recevoir un remboursement',
    add_pet_update_balance_title: 'Mettre à jour le solde',
    add_pet_checkout_title: 'Continuer le paiement',
    pet: 'Chien',
    pets: 'Chiens',
    remove_invite_note: 'ne figurera plus sur la liste des invités',
    are_you_sure: 'Sûr ?',
    cookie_disclaimer:
        'Vacasa utilise des cookies propriétaires et des cookies de sites tiers. En utilisant nos sites, vous acceptez notre politique en matière de cookies.',
    read_cookie_policy: 'Lisez notre politique en matière de cookies',

    sitemap: 'Plan du site',
    privacy: 'Vie privée',
    terms_of_service: "Conditions d'utilisation",

    property_management: 'Gestion des Locations Saisonnières',
    real_estate: 'Immobilier',
    innovation: 'Innovation',
    company: 'Société',
    about_us: 'Qui Sommes-nous',
    blog: 'Blog',
    careers: 'Emplois',
    newsroom: 'Salle de Presse',
    investors: 'Investisseurs',
    community: 'Communauté',
    social_responsibility: 'Responsabilité Sociale',
    leadership: 'Leadership',
    solutions_partnerships: 'Solutions et Partenariats',
    accessibility: 'Accessibilité',
    help: 'Aide',
    support_contact: 'Assistance et Contact',
    toll_free: 'Numéro Gratuit:',
    local: 'Local:',
    covid_update: 'Mises à jour COVID-19',
    hi: 'Bonjour, ',
    my_trips: 'Mes Voyages',
    favorites: 'Favoris',
    profile: 'Profil',
    logout: 'Se Déconnecter',
    owner_login: 'Connexion Propriétaire',
    owner_portal: 'Compte Propriétaire',
    login: 'Guest Login / Signup',
    find_my_trip: 'Trouver Mon Voyage',
    my_account: 'Inscription / Connexion',
    language_and_currency: 'Langue',

    somethings_not_right: 'Il y a une anomalie',
    an_error_occurred: 'Il y a eu une erreur lors du traitement de votre demande',
    try_later_or_call: 'Veuillez essayer plus tard ou appeler Vacasa au',
    reservation_info_unavailable: 'Information Indisponible',

    something_went_wrong: "Oh oh, quelque chose s'est mal passé",
    error_cancelling: "Une erreur s'est produite lors de l'annulation de votre réservation.",
    contact_customer_service: "Veuillez contacter le service client au {phone} pour plus d'assistance",

    identity_check_required: 'La vérification de votre identité est nécessaire pour poursuivre',
    verify_identity: 'Vérifier votre identité',

    already_completed_idv: `L'avez-vous déjà terminé?`,
    click_here: 'Cliquez ici',

    guest_portal_unavailable: 'Trip Manager n’est pas disponible',
    resolve_issues_calling: 'Pour résoudre ce problème, veuillez contacter Vacasa au',

    session_expired: 'Session expirée',
    session_expired_message: 'La session a expiré. Redirection vers',

    access_token_expired: 'Session expirée',
    access_token_expired_message: 'La session a expiré. Vous êtes redirigé pour rafraîchir votre session.',

    trip_overview_capitalized: 'Aperçu de Voyage',
    getting_there_capitalized: 'Accès',
    modify_your_trip_capitalized: 'Modifier votre voyage',
    checkout_instructions_capitalized: 'Instructions pour le départ',
    view_receipt_capitalized: 'Voir Reçu',

    trip_eligibility_trip_already_started:
        'Chouette ! Votre voyage a commencé ! Si vous devez encore modifier votre voyage, veuillez appeler Vacasa au',
    trip_eligibility_pending_payment: 'Votre paiement est en cours de traitement. Réessayez dans 24 heures pour modifier votre voyage.',
    trip_eligibility_created_before_june_fourth_2018: 'Si vous devez encore modifier votre voyage, veuillez appeler Vacasa au',
    trip_eligibility_negative_balance:
        'Votre remboursement est en cours de traitement. Réessayez dans 24 heures pour modifier votre voyage.',
    trip_eligibility_not_allowed_for_occupancy:
        'Nous sommes désolés, il n’est pas possible de modifier les invités/chiens pour cette réservation.',
    trip_eligibility_refund_in_progress:
        "Vous avez un remboursement en cours. Veuillez patienter jusqu'à ce qu'il soit traité pour modifier votre occupation",

    wheres_my_receipt: 'Où se trouve le reçu de ma réservation ?',
    channel_receipt_note:
        "Vous avez effectué votre réservation auprès de l'un de nos partenaires de réservation. Veuillez contacter l'entreprise avec laquelle vous avez réservé pour accéder à votre reçu et à vos informations de paiement.",

    download_app_mobile_note: "Détails du voyage, informations d'enregistrement et plus.",
    download_app_mobile_title: 'Obtenez tout dans app',

    payment_title: 'Effectuer un paiement',
    receipt_title: 'Le Reçu',
    addons_title: 'Complémentaires de voyage',
    latecheckout_title: 'Ajouter départ tardif',
    modify_trip_title: 'Modifier le voyage',

    pool_heat_add_or_remove: 'Ajouter ou retirer la chaleur de la piscine',

    submit_guest_edition: "Soumettre la mise à jour de l'invité",
    confirm_guest_remove: "Confirmer la suppression de l'invité",

    rent: 'Louer',
    fees: 'Tarifs',
    taxes: 'Les taxes',
    trip_protection: 'Protection de voyage',
    not_purchased: 'Non acheté',
    previous_balance: 'Solde précédent',
    sub_total: 'Sous-total ',
    pet_refund: 'Remboursement pour chien',
    adult_added: 'Adulte ajouté',
    adults_added: 'Adultes ajoutés',
    pet_added: 'Chien ajouté',
    pets_added: 'Chiens ajoutés',
    child_added: 'Enfant ajouté',
    children_added: 'Enfants ajoutés',
    child: 'Enfant',
    children: 'Enfants',

    payment_processed_by: 'Paiement traité par:',
    billing_address: 'Adresse de facturation:',

    ready_to_checkout: '¿Prêt à vérifier?',
    note_early_checkout:
        "Cliquez pour confirmer que vous passez à la caisse. Cela informera également notre équipe d'entretien que vous êtes parti.",
    checkout_now: 'Passer à la caisse',
    not_ready_yet: 'Je ne suis pas encore prêt',
    all_set: 'Tout ensemble!',
    note_confirm_early_checkout: 'Merci, votre commande est terminée. Nous espérons vous accueillir à nouveau bientôt!',
    got_it: 'Aucun problème',
    note_cancel_early_cehckout:
        'Vous pouvez effectuer votre commande avant {checkout}. Lorsque vous êtes prêt, cliquez à nouveau sur le lien de paiement dans le message texte que nous vous avons envoyé.',

    receipt_thirty_party_channel: "Merci d'avoir réservé votre maison Vacasa via {channel}",

    covid19_text: "Mise à jour sur le coronavirus (COVID-19) et nouvelles politiques d'annulation",
    covid19_button_text: 'Voir les mises à jour',
    covid19_link: 'https://www.vacasa.com/support/coronavirus-covid-19',

    square_feet: 'pieds carrés',

    please_upgrade_browser: 'Navigateur non pris en charge',
    browser_deprecated: 'Veuillez mettre à niveau ou utiliser un autre navigateur pour afficher ce site',

    know_before_you_go: 'A savoir avant de partir',
    import_details: 'Détails importants',
    directions_and_parking_details: 'Directions et détails de stationnement',
    note_for_our_guests: 'Notes pour nos clients',

    cannot_perform_action_title: "Cette page n'est pas disponible pour le moment",
    cannot_perform_action_message: 'Veuillez essayer plus tard ou appeler Vacasa au',

    fsc_credits: 'Future Stay Credits',

    address: 'Adresse',
    features_and_amenities: 'Caractéristiques et commodités',
    features_and_amenities_capitalized: 'Caractéristiques et Commodités',

    cancel_trip_title: 'Annuler Votre Voyage',
    cancel_your_reservation: 'Annuler Votre Réservation',

    payment_form_add_night: 'Ajouter une nuit',
    payment_form_add_night_note: 'Votre nouvelle heure de départ sera',
    payment_form_pricing_details: 'Détails des prix',
    payment_form_pricing_discounted_rent: 'Loyer réduit',
    payment_form_pricing_discount: 'Remise',
    payment_form_total: 'Total',
    payment_form_billing_information: 'Détails de facturation',
    payment_form_billing_name: 'Nom de facturation',
    payment_form_country: 'De campagne',
    payment_form_city: 'Ville',
    payment_form_state: 'État',
    payment_form_island: 'Île',
    payment_form_zip_code: 'Code Postal',
    payment_form_postal_code: 'Code Postal',
    payment_form_province: 'Province',
    payment_form_department: 'Département',
    payment_form_city_or_town: 'Ville/Village',
    payment_form_region: 'Région',
    payment_form_county: 'Comté',
    payment_form_area: 'Zone',
    payment_form_parish: 'Paroisse',
    payment_form_prefecture: 'Préfecture',
    payment_form_emirate: 'Emirat',
    payment_form_governorate: 'Gouvernorat',
    payment_form_card_number: 'Numéro de carte',
    payment_form_expiration_date: "Date d'expiration",
    payment_form_expiration_month: "Mois d'expiration",
    payment_form_expiration_year: "Année d'expiration",
    payment_form_security_code: 'Code de sécurité',
    payment_form_payments_note: 'Nous acceptons la plupart des cartes de crédit',
    payment_form_pay_now: 'Payez maintenant',
    payment_form_visa: 'Visa',
    payment_form_master_card: 'Master',
    payment_form_discover: 'Discover',
    payment_form_reservation_details: 'Détails de la réservation',
    payment_form_adult: 'Adulte',
    payment_form_adults: 'Adultes',
    payment_form_child: 'Enfant',
    payment_form_children: 'Enfants',
    payment_form_month: 'Mois',
    payment_form_year: 'An',
    payment_successful: 'Tout est prêt!',
    payment_successful_note:
        'Profitez de cette nuit supplémentaire de vacances. Vous trouverez ci-dessous vos détails de paiement et vérifiez votre boîte de réception pour un e-mail de confirmation avec vos nouvelles dates de voyage.',
    payment_failed: "Nous n'avons pas pu traiter votre paiement",
    payment_call_us_to_complete: 'Ne vous inquiétez pas, pour l’instant, nous vous réservons la nuit supplémentaire.',
    payment_call_us_to_complete_start: 'Appelez',
    payment_call_us_to_complete_end: 'pour payer par téléphone et confirmer la modification de votre voyage.',
    payment_form_removed: 'Supprimé',
    payment_form_added: 'Ajouté',
    payment_successful_generic_note: 'Votre voyage est mis à jour. Voici votre confirmation de paiement.',
    payment_trip_paid_in_full: 'Votre voyage est entièrement payé.',
    payment_successful_add_pet_adjustment_note:
        'Vous avez ajouté {total} {pet} à votre séjour. Que les queues remuent. Voici votre confirmation de paiement.',
    payment_successful_add_pet_adjustment_refund_note:
        'Vous avez supprimé {total} {pet} de votre séjour. Nous vous rembourserons tous les frais pour animaux payés dans les 5 jours ouvrables.',
    payment_successful_add_pool_heat_adjustment_note:
        'Vous avez ajouté le chauffage de la piscine à votre séjour. Voici votre confirmation de paiement.',

    modal_adjustment_not_available_continue: 'Continuez',
    modal_adjustment_not_available_back_to_trip: 'Retour aux détails du voyage',
    modal_adjustment_not_available_title: "Cette nuit n'est plus disponible",
    modal_adjustment_not_available_note_start:
        "Désolé, nous ne pouvons pas ajouter la nuit supplémentaire à votre voyage. (Un autre client a déjà réservé ou l'offre a expiré.)",
    modal_adjustment_not_available_note_end: 'Nous espérons que vous passerez encore un excellent séjour!',

    modal_adjustment_pending_balance_title: 'Payez votre solde pour débloquer cette offre',
    modal_adjustment_pending_balance_note_start: "Avant d'ajouter une nuit, vous devrez payer le solde actuel de votre voyage.",
    modal_adjustment_pending_balance_note_end: 'Une fois que vous avez payé, vous pouvez revenir à votre adresse e-mail et réessayer.',

    modal_lco_adjustment_not_available_title: `Départ tardif non disponible`,
    modal_lco_adjustment_not_available_note_start: `Désolé, nous ne pouvons pas ajouter de départ tardif à votre séjour.`,
    modal_lco_adjustment_pending_balance_note_start: "Avant d'ajouter le départ tardif, vous devrez payer le solde actuel de votre voyage.",

    night_added: 'nuit ajoutée',
    nights_added: 'nuits ajoutées',

    maintenance_window_title: 'Cette page est en maintenance',
    maintenance_window_note: 'Nous serons à nouveau en direct très bientôt. Merci de votre patience',
    maintenance_go_to_home: "Aller à la page d'accueil",
    maintenance_link: 'https://www.vacasa.com',

    modal_cancel_go_to_my_trips: 'Aller à Mes voyages',
    modal_cancel_title: 'Réservation annulée',
    modal_cancel_note: 'Votre réservation a été annulée avec succès',

    billing_information_note: 'Si prega di rivedere le modifiche e confermare per completare gli aggiornamenti di viaggio.',

    adjustment_failed_title: "Nous n'avons pas pu modifier votre voyage",

    whats_nearby: 'À proximité',
    whats_nearby_capitalized: 'À Proximité',
    checkout_best_of_city:
        'Découvrez le meilleur de {unitCity} pendant que vous êtes ici. Explorez les restaurants populaires, les attractions et bien plus autour de {unitName}.',
    banking: 'Banque',
    restaurants_and_coffee: 'Restaurants et cafés',
    groceries: 'Épiceries',
    hospitals: 'Hôpitaux',
    movie_theaters: 'Cinémas',
    bars_and_nightlife: 'Bars et vie nocturne',
    parks: 'Parcs',
    pharmacies: 'Pharmacies',
    shopping: 'Shopping',
    sports: 'Deportes',
    universities: 'Universités',
    tourist_attractions: 'Attractions touristiques',
    filter_by_category: 'Filtrer par catégorie',

    star_rating_title: 'Revoir votre séjour',
    star_rating_note: "Comment s'est passée votre expérience chez {unitName}? Votre avis est important pour nous.",
    next: 'Next',

    pay_balance_issue: 'Appelez {phone} pour payer et confirmer la modification de votre voyage.',

    chat_default_message: `Bonjour, comment pouvons-nous vous aider aujourd'hui?`,
    chat_default_name: 'Vacasa Customer Service',
    chat_start_new_button: 'Démarrer une nouvelle conversation',
    chat_start_content: 'Merci d´avoir discuté avec nous!',
    chat_open: 'Live-Chat ist verfügbar',
    chat_message_close:
        'Malheureusement, vous nous avez contactés en dehors des heures de chat en direct. Pour une assistance immédiate, veuillez appeler notre ligne d´assistance 24 heures sur 24.',
    chat_rule_close: '{openTime} à {closeTime}.',
    chat_rule: 'tous les jours de {openTime} à {closeTime}.',
    chat_error: 'Erreur lors de l`initialisation du chat',
    chat_loading: 'Chargement en cours ...',
    chat_me: 'Moi',

    extended_stay_capitalized: 'Prolonge mon Séjour',
    extended_stay_rules: "Sélectionnez jusqu'à 4 nuits supplémentaires avant ou après votre voyage prévu pour prolonger votre séjour.",
    extended_stay_success_alert_plural: '<b>{numberNights} nuits</b> ajoutées à votre itinéraire pour <b>{price}</b>',
    extended_stay_success_alert: '<b>1 nuit</b> ajoutée à votre itinéraire pour <b>{price}</b>',
    extended_stay_error_message:
        "Désolé, une erreur s'est produite. Pour parler avec un représentant du service à la clientèle, appelez le 1-800-544-0300",
    extended_stay_note_message: "Vos nouvelles dates d'arrivée et de départ seront",
    check_in: 'Check in',
    check_in_description: 'Dates d`arrivée disponibles antérieures:',
    check_out: 'Check out',
    adult: 'Adulte',
    adults: 'Adultes',
    check_out_description: 'Dates de départ disponibles ultérieurement:',
    empty_calendar_before_options: '* Malheureusement, toutes les dates avant votre voyage ne sont pas disponibles.',
    empty_calendar_after_options: '* Malheureusement, toutes les dates après votre ne sont pas disponibles.',
    payment_form_add_extended_stay: '{days} Nuits supplémentaires',
    today: "Aujourd'hui",
    clear: 'Effacer',
    checkout: 'Paiement',
    reset_dates: 'Réinitialiser les Dates',
    total_cost: 'Coût total',

    late_check_out_capitalized: 'Ajouter un départ tardif',
    payment_form_add_late_check_out_note: 'Votre nouvelle heure de départ sera',
    payment_form_add_late_check_out: 'Départ tardif ajouté',

    bedroom_title: 'Répartition des lits',
    view_all_beds: 'Voir toutes les {total} répartitions des lits',
    view_less: 'Voir moins',
    view_more: 'Voir plus',

    pool_heat_capitalized: 'Ajouter la climatisation de piscine',

    pal_res_question_panel_text:
        "Ce logement est géré par {name}. Pour obtenir de l'aide, veuillez envoyer un e-mail à {email} ou nous appeler au {phoneNumber}.",
    pal_res_question_panel_text_email_only:
        "Ce logement est géré par {name}. Pour obtenir de l'aide, veuillez envoyer un e-mail à {email}.",
    pal_res_question_panel_text_phone_only: "Ce logement est géré par {name}. Pour obtenir de l'aide, nous appeler au {phoneNumber}.",

    pal_cancellation_contact_text:
        'Pour demander une annulation, veuillez contacter {name} en envoyant un e-mail à {email} ou en appelant {phoneNumber}.',
    pal_cancellation_contact_text_email_only: 'Pour demander une annulation, veuillez contacter {name} en envoyant un e-mail à {email}.',
    pal_cancellation_contact_text_phone_only: 'Pour demander une annulation, veuillez contacter {name} en appelant {phoneNumber}.',

    pal_agreement_details_house_rules_text:
        "Veuillez prendre un moment pour consulter les règles de la maison ci-dessous. Elles s'appliquent à votre séjour dans ce logement.",
    rental_terms: 'Conditions de location',
    view_terms: 'Voir les conditions',
    request_cancellation: "Demander l'annulation",
    review_cancellation_policy: "Vérifier la politique d'annulation",
    pricing_details: 'Détails des prix',
    view_details: 'Voir les détails',
};
